var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var SectionHeading = styled.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  color:  ", ";\n  font-size: 3.2rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.2em;\n  margin-top: 0;\n  margin-bottom: 30px;\n  \n"], ["\n  display: block;\n  color:  ", ";\n  font-size: 3.2rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.2em;\n  margin-top: 0;\n  margin-bottom: 30px;\n  \n"])), function (props) { return props.color ? props.color : function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.sectionHeading.color;
}; });
var templateObject_1;
//# sourceMappingURL=SectionHeading.js.map